export default __webpack_public_path__ + "static/media/angbao-bonus.391dc897.webp";